import {createStore} from 'vuex'
import axiosApi from "@/utils/axiosApi";
import {Base64} from "js-base64";

export default createStore({
    state: {
        account: {},
        order: {},
        coupon: "",
        product: {}
    },
    getters: {},
    mutations: {
        setOrder(state, value) {
            this.state.order = value
        },
        removeAccount(){
            window.sessionStorage.removeItem('diff_account')
            this.state.account = {}
        },
        setCoupon(state,value){
            window.sessionStorage.setItem("coupon",value)
            this.state.coupon = value
        },
        getCoupon(){
            this.state.coupon = window.sessionStorage.getItem("coupon")
        },
        setProduct(state,value){
            window.sessionStorage.setItem("product",JSON.stringify(value))
            this.state.product = value
        },
        getProduct(){
            this.state.product = JSON.parse(window.sessionStorage.getItem("product"))
        }
    },
    actions: {
        setAccounts(state, value) {
            window.sessionStorage.setItem("diff_account", JSON.stringify(value))
            this.state.account = value
        },
        getAccounts() {
            let accounts = window.sessionStorage.getItem("diff_account")
            if (!accounts) {
                this.state.account = {}
                return;
            }
            accounts = JSON.parse(accounts)
            //校验会员登录
            new axiosApi({
                encode: "site",
                method: "user/check_login",
                body: {
                    cust_id: accounts.cust_id,
                    token: accounts.token
                }
            }).send((res) => {
                if (res.message.code !== "000") {
                    window.sessionStorage.removeItem("diff_account")
                    this.state.account = {}
                    return
                }
                let dat = res.data
                dat.phoneNumber = /^1[2-9]\d{9}$/.test(dat.phoneNumber) ? dat.phoneNumber : Base64.decode(dat.phoneNumber)
                window.sessionStorage.setItem("diff_account", JSON.stringify(dat));
                this.state.account = dat
                return dat;
            }, () => {
                window.sessionStorage.removeItem("diff_account")
                this.state.account = {}
                return false
            })
        }
    },
    modules: {}
})
